export const GET_DATA_FROM_SERVER_API_CALL = 'GET_DATA_FROM_SERVER_API_CALL';
export const GET_DATA_FROM_SERVER_API_CALL_SUCCESS =
  'GET_DATA_FROM_SERVER_API_CALL_SUCCESS';
export const GET_DATA_FROM_SERVER_API_CALL_FAIL =
  'GET_DATA_FROM_SERVER_API_CALL_FAIL';
export const LOG_OUT = 'LOG_OUT';
export const CLEAR_DATA_BY_KEY = 'CLEAR_DATA_BY_KEY';
export const IS_ERROR_CLEAR = 'IS_ERROR_CLEAR';


